import React from "react"
import { Tel } from "@pga/pga-component-library"

import { Title } from "./styled"
import { hasNullCurrentLevel, hasLinkAndLevel } from "./utils"
import { isTerminated } from "../../../utils"
import {
  shouldShowSuspensionWarning,
  getAllActiveSuspensions,
  getSuspensionMessage,
} from "../../MembershipJourney/utils/suspensionUtils"
import { useMembershipJourneyContext } from "../../MembershipJourney/MembershipJourneyContext"

export const MessagePurchaseLink = ({
  me,
  nextLevel,
  purchaseLink,
  title: { completed, Contact },
}) => (
  <Title>
    {completed}
    {Contact && <Contact />}
    {hasLinkAndLevel(purchaseLink, nextLevel)() && (
      <>
        <a
          href={`${purchaseLink(me.pgaId)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="pl-1"
        >
          Purchase Level {nextLevel}
        </a>{" "}
        now to continue.
      </>
    )}
  </Title>
)

export const MessageTerminated = () => (
  <Title>
    Your membership is not <u className="text-danger">current</u>. Please
    contact PGA Membership Services at <Tel phoneNumber="(800) 474-2776" />
  </Title>
)

export const MessageSuspended = () => {
  const { pgmProgress } = useMembershipJourneyContext()
  const suspensions = getAllActiveSuspensions(pgmProgress)

  if (suspensions.length === 0) return null

  return suspensions.map((suspensionData, index) => {
    const message = getSuspensionMessage(suspensionData)
    return message ? <Title key={index}>{message}</Title> : null
  })
}

export const MessageDefault = ({ title = {} }) => (
  <Title>{title.inProgress}</Title>
)

const Message = ({ title, nextLevel, purchaseLink }) => {
  const { me, pgmProgress } = useMembershipJourneyContext()

  if (isTerminated(me)) {
    return <MessageTerminated />
  }

  if (shouldShowSuspensionWarning(pgmProgress)) {
    return <MessageSuspended />
  }

  if (hasNullCurrentLevel(me)) {
    return <MessagePurchaseLink {...{ me, title, nextLevel, purchaseLink }} />
  }

  return <MessageDefault {...{ title, nextLevel, purchaseLink }} />
}

export default Message
